<div class="form-group">
  <label [for]="name" *ngIf="label">{{ placeholder | titlecase }}</label>
  <input
    [disabled]="disabled"
    (ngModelChange)="eventChange($event)"
    [mask]="mask"
    [thousandSeparator]="separator"
    [decimalMarker]="decimalMarker"
    [pattern]="pattern"
    [suffix]="' ' + suffix"
    [type]="type"
    class="form-control"
    [id]="name"
    [name]="name"
    [placeholder]="placeholder | titlecase"
    [ngModel]="model"
    #errorModel="ngModel"
    [required]="required"
    autocomplete="off"
  />
  <span
    class="text-danger"
    *ngIf="(model || myForm.submitted) && errorModel.errors?.required"
  >
    Il campo {{ placeholder }} è obbligatorio
  </span>
</div>
